import React from 'react'

import { Button } from 'modules/ui'
import Element from '../../Element'

import enhance from './enhancers'

export function Preview({ completed, part, theme, handleGameResult }) {
  const { counterargument, evidence, reasoning } = part

  return (
    <div className={theme.preview}>
      <div className={theme.elements}>
        <Element text={evidence} type="evidence" />
        <Element text={reasoning} type="reasoning" />
        <Element text={counterargument} type="counterargument" />
      </div>

      <Button
        primary
        raised
        onClick={handleGameResult}
        className={theme.button}
        disabled={!completed}
        icon="arrow_forward"
        to="review"
      />
    </div>
  )
}

export default enhance(Preview)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Preview/index.js